import { types, getEnv, SnapshotOut, Instance } from 'mobx-state-tree';
import { observable } from 'mobx';
import { cashOutDtos } from '../../dtos';
import { ICommonAppEnvWithSBBaseApi } from '../index';
import { translation } from '../../../../localization/localization';

export const CashOUtListItem = types.model('cashOutListItem', {
    betId: types.number,
    stake: types.number,
    possiblePayout: types.number,
    cashOut: types.number,
    time: types.Date,
    cashOutDate: types.Date,
    betType: types.maybeNull(types.number)
});

const CashOutListKey = 'cashOutList';
export const CashOutListStore = types
    .model(CashOutListKey, {
        isLoading: types.boolean,
        isAvailable: types.boolean,
        bets: types.optional(types.array(CashOUtListItem), []),
        errorMessage: types.maybeNull(types.string)
    })
    .views(self => ({
        get currency() {
            return getEnv<ICommonAppEnvWithSBBaseApi>(self).settings.currency;
        },
        get isAllowed() {
            return self.isAvailable;
        }
    }))
    .actions(self => {
        const setData = (data: cashOutDtos.CashOutResponse) => {
            self.bets = observable([]);
            data.Bets.forEach(item => {
                self.bets.push(
                    CashOUtListItem.create(<SnapshotOut<typeof CashOUtListItem>>{
                        betId: item.BetID,
                        cashOut: item.CashOut,
                        possiblePayout: item.PrizePotential,
                        time: new Date(item.Date).getTime(),
                        stake: item.Amount,
                        betType: item.BetType,
                        cashOutDate: new Date(item.CashOutDate).getTime()
                    })
                );
            });
            self.isLoading = false;
            self.errorMessage = null;
        };

        const setIsError = () => {
            self.isLoading = false;
            self.errorMessage = translation().general_ProgressContentError;
        }

        const setIsLoading = () => {
            self.isLoading = true;
        }

        const setIsAllowed = (value: boolean) => {
            self.isAvailable = value;
        };

        return {
            setData,
            setIsError,
            setIsAllowed,
            setIsLoading
        };
    });

export type ICashOutListStore = Instance<typeof CashOutListStore>;